import React, { Fragment, useEffect, useState } from "react";
import DataTable from "../../../../Common/Components/DataTable";
import { Helmet } from "react-helmet";
import CustomModal from "../../../../Common/Components/Modal/CustomModal";
import { useProblem } from "../Hooks";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
function Index() {
  const {
    list,
    loading,
    getData,
    handlerSearch,
    sortHandler,
    modal,
    setModal,
    toggleStatus,
    filter,
    setForm,
    form,
    loadingBtn,
  } = useProblem();
  useEffect(() => {
    if (modal.modal == false) getData();
  }, [modal.modal]);
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | کاربران دارای مشکل</title>
      </Helmet>
      <DataTable
        loading={loading}
        heads={[
          {
            title: "نام کاربر",
            key: "fullname",
          },
          {
            title: "َشماره کاربر",
            key: "mobile",
          },
          {
            title: "محل مشکل",
            key: "path",
          },

          {
            title: "نوع درخواست",
            key: "type",
            type: "enum",
            enum: {
              called: " تماس کاربر",
              reqcall: "تماس پشتیبان",
            },
          },
          {
            title: "وضعیت",
            key: "status",
            type: "enum",
            enum: {
              done: "برطرف شده",
              waiting: "منتظر تماس پشتیبان",
              notanswer: "بدون پاسخ کاربر",
            },
          },
          {
            title: "نوع کاربر",
            keyName: "role",
            type: "state",
            method: row => {
              if (row) {
                if (row.user) {
                  switch (row && row.user && row.user.role) {
                    case "user":
                      return "کاربر معمولی";
                    case "manager":
                      return "مدیر مجموعه";
                    case "classmanager":
                      return "برگزار کننده کلاس";
                  }
                } else {
                  return "ثبت نشده";
                }
              } else {
                return "ثبت نشده";
              }
            },
          },
          {
            title: "تاریخ",
            key: "created_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        textEmpty="کاربری مشکلی ثبت نکرده است"
        list={list && list.data}
        data={list}
        search={handlerSearch}
        function={getData}
        currentPage={list && list.data && list.data.current_page}
        header=" لیست اطلاعات کاربران"
        linkbtn="/Admin/User/Create"
        links={[
          {
            size: "col-6",
            selected: true,
            typeLink: "div",
            html: (
              <FormControl fullWidth size="small">
                <InputLabel id="demo-multiple-name-label">وضعیت</InputLabel>
                <Select
                  labelId="demo-multiple-name-label"
                  onChange={e => {
                    sortHandler(e.target.value);
                  }}
                  label={"نمایش بر اساس"}
                  value={filter}
                >
                  <MenuItem value={"waiting"}> منتظر تماس پشتیبان</MenuItem>
                  <MenuItem value={"done"}>برطرف شده</MenuItem>
                  <MenuItem value={"notanswer"}>بدون پاسخ کاربر</MenuItem>
                </Select>
              </FormControl>
            ),
          },
          {
            function: selected => {
              setModal({
                ...modal,
                modal: selected[0],
                modalData:
                  list &&
                  list.data &&
                  list.data
                    .filter(ele => ele.id == selected[0])
                    .filter(Boolean)[0],
              });
            },
            color: "primary",
            size: "col-md-5",
            html: "نمایش توضیحات",
            multi: false,
            type: "show",
            main: true,
          },
        ]}
      />
      <CustomModal
        size={"md"}
        show={modal.modal}
        handleClose={() => {
          setModal({
            ...modal,
            modal: false,
          });
        }}
        header={"بررسی مشکل"}
      >
        {modal && modal.modalData && modal.modalData.status == "waiting" ? (
          <Toggle
            form={form}
            setForm={setForm}
            loadingBtn={loadingBtn}
            submit={toggleStatus}
          />
        ) : (
          <ShowDescribe data={modal.modalData} />
        )}
      </CustomModal>
    </Fragment>
  );
}
const Toggle = ({ form, setForm, loadingBtn, submit }) => {
  return (
    <div>
      <div className="my-2 text-center">
        پشتیبان گرامی اگر کاربر پاسخگو نبود متن گزارشی از تعداد تماس و ساعت تماس
        در فرم پرد کنید و گزینه عدم پاسخ کاربر را نیز بزنید و اگر کاربر پاسخ داد
        گزارش کاملی از مشکل پیش آمده در فرم زیر یادداشت کنید
      </div>
      <div>
        <label htmlFor="describe">مشکل کاربر را توضیح دهید :</label>
        <textarea
          name="describe"
          id="describe"
          cols="30"
          rows="5"
          className="form-group w-100"
          onChange={e => {
            setForm({ ...form, describe: e.target.value });
          }}
        ></textarea>
      </div>
      <div className="d-flex align-items-center">
        <input
          checked={form.action == "notanswer"}
          type="checkbox"
          name="notanswer"
          id="notanswer"
          onChange={() => {
            setForm({
              ...form,
              action: form.action == "done" ? "notanswer" : "done",
            });
          }}
        />
        <label htmlFor="notanswer" style={{ marginRight: "5px" }}>
          عدم پاسخ کاربر
        </label>
      </div>
      <div className="d-flex justify-content-end w-100">
        <div>
          <button
            className=" btn btn-success"
            onClick={() => {
              submit();
            }}
            disabled={form.describe == ""}
          >
            {loadingBtn ? "در حال ارسال" : "ثبت گزارش"}
          </button>
        </div>
      </div>
    </div>
  );
};
const ShowDescribe = ({ data }) => {
  const HandleType = data => {
    switch (data) {
      case "reqcall":
        return "تماس پشتیبان";
      case "called":
        return "تماس کاربر";
      case "user":
        return "کاربر";
      case "manager":
        return "مدیر مجموعه";
      case "classmanager":
        return "برگزار کننده";
    }
  };
  return (
    <div>
      <div className="row">
        <div className="col-md-6">
          <div>نام کاربر :</div>
          <div className="my-2">
            <p style={{ fontWeight: "400" }}>{data.fullname}</p>
          </div>
        </div>
        <div className="col-md-6">
          <div>شماره کاربر :</div>
          <div className="my-2">
            <p style={{ fontWeight: "400" }}>{data.mobile}</p>
          </div>
        </div>
        <div className="col-md-6">
          <div>نوع کاربر :</div>
          <div className="my-2">
            <p style={{ fontWeight: "400" }}>
              {data && data.user && HandleType(data.user.role)}
            </p>
          </div>
        </div>
        <div className="col-md-6">
          <div>محل مشکل :</div>
          <div className="my-2">
            <p style={{ fontWeight: "400" }}>{data.path}</p>
          </div>
        </div>
        <div className="col-md-6">
          <div>نوع درخواست :</div>
          <div className="my-2">
            <p style={{ fontWeight: "400" }}>{HandleType(data.type)}</p>
          </div>
        </div>
      </div>
      <div>شرح مشکل کاربر :</div>
      <div className="my-2">
        <p style={{ fontWeight: "400" }}>{data.describe}</p>
      </div>
    </div>
  );
};

export default Index;
